<template>
    <v-row style="padding-top:10px">
        <v-toolbar class="hidden-sm-and-down" elevation="0" style="border-radius: 3px;" flat color="primary">
            <v-toolbar-items style="border-radius: 3px;" flat elevation="0" class="hidden-sm-and-down">
                <v-menu v-if="permisoFianzas" class="hidden-md-and-up" :close-on-content-click="false"
                    :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on"
                            @click="$router.push({ name: 'FinanzasPrincipal' }).catch((error) => error);">
                            <span style='color: white; font-size: 16px;'>Fianzas</span>
                        </v-btn>
                    </template>
                </v-menu>
                <v-menu content-class="menu-content" class="alturaMenu" :close-on-content-click="false"
                    v-if="deposReferenciado" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="irDeposito()" color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Deposito Referenciado</span>
                        </v-btn>
                    </template>

                </v-menu>
                <v-menu v-if="permisoRecuperaciones" class="hidden-md-and-up" :close-on-content-click="false"
                    :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" text elevation="0" v-on="on">
                            <span style='color: white; font-size: 16px;'>Recuperaciones</span>
                        </v-btn>
                    </template>
                    <v-list style="width: 300px !important; z-index:65 !important">
                        <v-list-item
                            @click="$router.push({ name: 'SeguimientoRecuperaciones' }).catch((error) => error);"
                            class="listElement">
                            <v-list-item-title>Activos</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="$router.push({ name: 'EstadisticoRecuperaciones' }).catch((error) => error);"
                            class="listElement">
                            <v-list-item-title>Estadísticos</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="$router.push({ name: 'RecuperacionesPendientes' }).catch((error) => error);"
                            class="listElement">
                            <v-list-item-title>Pendientes</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>



            </v-toolbar-items>
        </v-toolbar>
        <v-toolbar class="hidden-md-and-up" elevation="0" style="border-radius: 3px;" flat color="primary">
            <v-toolbar-items style="border-radius: 3px;" flat elevation="0">
                <v-menu :close-on-content-click="false" :open-on-hover="false" bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="white" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list style="width: 400px !important; z-index:65 !important">
                        <v-list-group v-if="permisoFianzas" no-action
                            @click="$router.push({ name: 'FinanzasPrincipal' }).catch((error) => error);">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Fianzas</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-group no-action v-if="deposReferenciado" @click="irDeposito()">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Deposito Referenciado</v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-list-group no-action v-if="permisoRecuperaciones">
                            <template v-slot:activator>
                                <v-list-item style="margin-left: -5%;">
                                    <v-list-item-title>Recuperaciones</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list>
                                <v-list-item class="listElement">
                                    <v-list-item-title class="listChildElement"
                                        @click="$router.push({ name: 'SeguimientoRecuperaciones' }).catch((error) => error);">Activos</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement">
                                    <v-list-item-title class="listChildElement"
                                        @click="$router.push({ name: 'EstadisticoRecuperaciones' }).catch((error) => error);">Estadísticos</v-list-item-title>
                                </v-list-item>
                                <v-list-item class="listElement">
                                    <v-list-item-title class="listChildElement"
                                        @click="$router.push({ name: 'RecuperacionesPendientes' }).catch((error) => error);">Pendientes</v-list-item-title>
                                </v-list-item>

                            </v-list>

                        </v-list-group>


                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <!--<v-container class="hidden-md-and-up">

            <v-btn flat color="primary" @click="toggleMenu = !toggleMenu">
                <v-icon>mdi-menu</v-icon>
            </v-btn>
        </v-container>-->
    </v-row>
</template>
<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { mapActions, mapState } from "vuex";
import Indicadores from "@/services/Operacion/Indicadores.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            toggleMenu: false,
            groupOpened: false,
            permisoConcluidos: false,
            permisoExpJur: false,
            permisoReasignacion: false,
            estadisticageneral: false,
            estadisticarlv: false,
            estadisticajur: false,
            estadisticarobo: false,
            estadisticarcmedico: false,
            poderes: false,
            gnp: false,
            altas: false,
            permisoIndicadores: false,
            indicador: '',
            permisoRecuperaciones: false,
            permisoFianzas: false,
            deposReferenciado: false
        }
    },
    methods: {
        irDeposito() {
            window.open(this.domain.domainNameDev + "PrusiaGo/Utilidades/DepositoReferenciado")
        },
        async archivo(cliente) {
            if (cliente == 'Atlas') {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'ArchivoAtlas' });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'ArchivoGNP' });
            }
        },
        async llamar(cliente) {
            if (cliente == 'Atlas') {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'SeguimientoAtlas' });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte({ clclave: cliente }, "param");
                this.$router.push({ name: 'SeguimientoGNP' });
            }
        },
        showMenu() {
            return this.toggleMenu || this.$vuetify.breakpoint.mdAndUp
        }
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "15").then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });
    },
    async mounted() {
        let permiso = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '143');
        if (permiso.data.length > 0) {
            permiso.data.forEach(per => {
                if (per.peclave == 143) //permiso indicadores
                    this.permisoIndicadores = true;
            })
        }
        let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '317,292,28,47,133,42,298,41,132,275,269,325,311,98');
        if (response.data.length > 0) {
            response.data.forEach(permiso => {
                if (permiso.peclave == 292)//Permiso para ver concluidos
                    this.permisoConcluidos = true;
                if (permiso.peclave == 28)//Permiso para ver concluidos
                    this.permisoExpJur = true;
                if (permiso.peclave == 47)
                    this.permisoReasignacion = true
                if (permiso.peclave == 133)
                    this.estadisticageneral = true;
                if (permiso.peclave == 42)
                    this.estadisticajur = true;
                if (permiso.peclave == 298)
                    this.estadisticarobo = true;
                if (permiso.peclave == 41)
                    this.estadisticarlv = true;
                if (permiso.peclave == 132)
                    this.estadisticarcmedico = true;
                if (permiso.peclave == 275)
                    this.poderes = true;
                if (permiso.peclave == 269)
                    this.gnp = true;
                if (permiso.peclave == 325)
                    this.altas = true;
                if (permiso.peclave == 317)
                    this.permisoFianzas = true;
                if (permiso.peclave == 311)
                    this.permisoRecuperaciones = true;
                if (permiso.peclave == 98)
                    this.deposReferenciado = true;

            });
        }
        var formData = new FormData();
        formData.append("tipo", 42);
        let resp = await Indicadores.ObtenerParametro(formData);
        this.indicador = resp.panombre
    }

}
</script>
<style scoped>
.listChildElement {
    margin-left: 5%;
}

@media (max-height: 800px) {
    .menu-content {
        top: 145px !important;
    }
}



.listElement {
    cursor: pointer;
}

.listElement {
    margin: 2px;
    border-radius: 4px;
}

.listElement:hover {
    background: #d8f9ff;
}

.listElement:active {
    background: #d8f9ff;
}


.listParent {
    max-height: 4000px !important;
}

.listChildElementMob {
    margin-left: 5%;
}

.listElementMob {
    cursor: pointer;
}

.listElementMob {
    margin: 2px;
    margin-left: 5%;
    border-radius: 4px;
}

.listElementMob:hover {
    background: #d8f9ff;
}

.listElementMob:active {
    background: #d8f9ff;
}
</style>